import { sortSelfIdQuestionAnswers } from "@/components/utils/sortSelfIdentificationQuestionAnswers";
import { MultiFieldSet } from "@/components/utils/useFieldSet";
import { Select } from "@/flokit/compound/inputs/select/select";
import { JobAppSelfIdQuestionAnswerRequest } from "modules/api-docs";
import { PublicOrgSelfIdQuestionsQuery } from "modules/graphql.types";
import { SingleSelectEdit } from "../app-questions/single-select-edit";

export const SelfIdQuestionFragment = (
  props: MultiFieldSet<JobAppSelfIdQuestionAnswerRequest> & {
    questions: PublicOrgSelfIdQuestionsQuery["publicOrgSelfIdQuestions"][number][];
    isRequired: boolean;
  },
) => {
  return (
    <div className="space-y-6 pt-5">
      <div className="space-y-6">
        {props.questions?.map((question, index) => {
          const questionType = question?.questionType ?? "SINGLE_SELECT";
          const valueIndex = props.values?.findIndex(
            (x) => x?.orgSelfIdQuestionId === parseInt(question.id),
          );

          const options = (
            sortSelfIdQuestionAnswers(
              question?.orgSelfIdQuestionOptions ?? [],
            ) ?? []
          )
            .filter((n) => n && n.deletedAt == null)
            .map((o) => {
              return {
                ...o,
                orgSelfIdQuestionOptionId: o?.id,
                label: o?.name,
                value: o?.id,
              };
            });
          if (questionType === "SINGLE_SELECT") {
            const selectedOption = options.find((o) => {
              const allUserAnswers =
                props.values?.[valueIndex]
                  ?.jobAppSelfIdQuestionAnswerSelections ?? [];
              const relevantUserAnswer =
                allUserAnswers.find(
                  (a) =>
                    a != null && `${a.orgSelfIdQuestionOptionId}` === o.value,
                ) ?? null;
              return relevantUserAnswer;
            });
            return (
              <SingleSelectEdit
                subText={question?.label}
                label={question?.name}
                key={index}
                onBlur={props.onBlur("jobAppSelfIdQuestionAnswerSelections")}
                options={options}
                isRequired={props.isRequired}
                value={selectedOption}
                validationMessage={
                  props.validationMsg?.[valueIndex]
                    ?.jobAppSelfIdQuestionAnswerSelections
                }
                shouldShowValidation={
                  props.validation?.[valueIndex]
                    ?.jobAppSelfIdQuestionAnswerSelections
                }
                onChange={(v) => {
                  props.setValue(
                    valueIndex,
                    "jobAppSelfIdQuestionAnswerSelections",
                    v != null ? [v] : [],
                  );
                }}
                isInModal={false}
              />
            );
          }

          if (questionType === "MULTI_SELECT") {
            const selectedOptions =
              props?.values?.[
                valueIndex
              ]?.jobAppSelfIdQuestionAnswerSelections?.map((userAnswer) => {
                return {
                  ...userAnswer,
                  label: options.find(
                    (o) =>
                      o.value === `${userAnswer?.orgSelfIdQuestionOptionId}`,
                  )?.label,
                  value: `${userAnswer?.orgSelfIdQuestionOptionId}`,
                };
              }) ?? [];
            return (
              <Select
                isMulti
                label={question?.name}
                key={index}
                onBlur={props.onBlur("jobAppSelfIdQuestionAnswerSelections")}
                options={options}
                isRequired={props.isRequired}
                value={selectedOptions}
                validationMessage={
                  props.validationMsg?.[valueIndex]
                    ?.jobAppSelfIdQuestionAnswerSelections
                }
                shouldShowValidation={
                  props.validation?.[valueIndex]
                    ?.jobAppSelfIdQuestionAnswerSelections
                }
                onChange={(v) => {
                  props.setValue(
                    valueIndex,
                    "jobAppSelfIdQuestionAnswerSelections",
                    v != null ? v : [],
                  );
                }}
                isInModal={false} // Shouldn't be in a modal anywhere but Forward
              />
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};
